const settings = {
    mapSelector: '[js-map]',
    latAttribute: 'js-lat',
    lngAttribute: 'js-lng',
}

const loadScript = () => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GMAPS_API_KEY}&callback=initMap`
    document.body.appendChild(script);
}

if (document.querySelector('[js-map]')) {
    window.onload = loadScript;
}

window.initMap = () => {
    const mapElement = document.querySelector(settings.mapSelector);

    if (!mapElement) {
        return;
    }

    const lat = Number(mapElement.getAttribute(settings.latAttribute));
    const lng = Number(mapElement.getAttribute(settings.lngAttribute));

    const positionObj = {lat, lng};

    const styles = [
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e9e9e9"
            },
                {
                    "lightness": 17
            }
            ]
    },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
            },
                {
                    "lightness": 20
            }
            ]
    },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
            },
                {
                    "lightness": 17
            }
            ]
    },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#ffffff"
            },
                {
                    "lightness": 29
            },
                {
                    "weight": 0.2
            }
            ]
    },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
            },
                {
                    "lightness": 18
            }
            ]
    },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
            },
                {
                    "lightness": 16
            }
            ]
    },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
            },
                {
                    "lightness": 21
            }
            ]
    },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#dedede"
            },
                {
                    "lightness": 21
            }
            ]
    },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
            },
                {
                    "color": "#ffffff"
            },
                {
                    "lightness": 16
            }
            ]
    },
        {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
            },
                {
                    "color": "#333333"
            },
                {
                    "lightness": 40
            }
            ]
    },
        {
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
            }
            ]
    },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f2f2f2"
            },
                {
                    "lightness": 19
            }
            ]
    },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#fefefe"
            },
                {
                    "lightness": 20
            }
            ]
    },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#fefefe"
            },
                {
                    "lightness": 17
            },
                {
                    "weight": 1.2
            }
            ]
    }
    ];

    const map = new google.maps.Map(
        mapElement,
        {
            zoom: 15,
            center: positionObj,
            styles: styles,
            mapTypeControl: false
        }
    );

    const markerIcon = {
        path: "M18.5 0.25C8.34125 0.25 0.125 8.46625 0.125 18.625C0.125 32.4062 18.5 52.75 18.5 52.75C18.5 52.75 36.875 32.4062 36.875 18.625C36.875 8.46625 28.6588 0.25 18.5 0.25ZM18.5 25.1875C14.8775 25.1875 11.9375 22.2475 11.9375 18.625C11.9375 15.0025 14.8775 12.0625 18.5 12.0625C22.1225 12.0625 25.0625 15.0025 25.0625 18.625C25.0625 22.2475 22.1225 25.1875 18.5 25.1875Z",
        fillColor: '#5486DC',
        fillOpacity: 1,
        anchor: new google.maps.Point(0,0),
        strokeWeight: 0,
        scale: 1
    }

    new google.maps.Marker({
        position: positionObj,
        map,
        icon: markerIcon,
    });
}
